import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomReplaceTag = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="m12.41 2.58 9 9c.36.36.59.87.59 1.42s-.22 1.05-.59 1.41l-7 7c-.36.37-.86.59-1.41.59s-1.05-.22-1.41-.58l-.362-.362a6.002 6.002 0 0 1-8.286-8.286l-.352-.352C2.22 12.05 2 11.55 2 11V4c0-1.1.9-2 2-2h7c.55 0 1.05.22 1.41.58m.344 17.08a6.002 6.002 0 0 0-8.467-8.372L4 11V4h7v-.01l9 9-7 7.02zM8 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m.036 12.98a.3.3 0 0 0 .51.21l.978-.966a.297.297 0 0 0 0-.426l-.972-.972a.297.297 0 0 0-.51.21v.564a2.085 2.085 0 0 1-2.004-2.814.47.47 0 0 0-.102-.492.45.45 0 0 0-.744.15 3 3 0 0 0 .684 3.18A3 3 0 0 0 8 19h.036zm1.926-2.76c-.06.168-.03.36.102.492a.445.445 0 0 0 .738-.156 3 3 0 0 0-.684-3.18 2.96 2.96 0 0 0-2.16-.87v-.486a.3.3 0 0 0-.51-.21l-.972.972a.297.297 0 0 0 0 .426l.978.966c.186.192.51.06.51-.21V13.9a2.08 2.08 0 0 1 1.518.612c.6.6.756 1.464.48 2.208"
  />,
  'CustomReplaceTag',
);

export default CustomReplaceTag;
